export default function getFlexShrinkLg(shrink) {
  return shrink === false ? "lg:shrink-0" : shrink === true ? "lg:shrink" : "";
}
